import { io } from 'socket.io-client';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

let socket = null;

export const initSocket = (token) => {
  if (socket?.connected) return socket;

  socket = io(BASE_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
  });

  socket.on('connect', () => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[Socket] Connected:', socket.id);
    }
  });

  socket.on('disconnect', (reason) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[Socket] Disconnected:', reason);
    }
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const joinZone = (zoneId) => {
  socket?.emit('join_zone', zoneId);
};

export const emitLocation = (location) => {
  socket?.emit('responder_location', location);
};

export const emitMarkSafe = (userId) => {
  socket?.emit('mark_safe', userId);
};
